// extracted by mini-css-extract-plugin
module.exports = {"reservable-summary":"reservable-summary__3j1Bx","header":"header__2NTi1","time-range":"time-range__2CMS1","footer":"footer__E2cyP"};